import DepartmentItem from './DepartmentItem.gql';

export default DepartmentItem;
